import "./index.css";
import { BrowserRouter, useLocation } from "react-router-dom";
import Pages from "./pages/Index";
import { useEffect, useState } from "react";
import GoogleOneTapLogin from "react-google-one-tap-login";
import Loader from "./components/Loader";
import { disableSplashScreen } from "./api/enkripsi";
import Footer from "./components/Footer";
import { executePost } from "./functions/Kubuku";

const App = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [flagGoogle, setFlagGoogle] = useState(false);
  const [email, setEmail] = useState("");

  const location = useLocation();

  useEffect(() => {
    disableSplashScreen();
    setIsLoading(false);

    if (localStorage.getItem("name") == null) {
      setFlagGoogle(true);
    }
  }, []);

  useEffect(() => {
    if (email != "") {
      getTokenLogin();
    } else {
      getTokenLogin();
    }
  }, [email]);

  const firstSegment = "/" + location.pathname.split("/")[1];

  const hexToRgb = (hex) => {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result
      ? {
          r: parseInt(result[1], 16),
          g: parseInt(result[2], 16),
          b: parseInt(result[3], 16),
        }
      : null;
  };

  const getTokenLogin = async () => {
    const formData = new FormData();
    formData.append("email", email);

    const response = await executePost(
      "https://bintangpusnas.perpusnas.go.id/api/logVisitor",
      formData,
    );

    if (response.code == 200) {
      localStorage.setItem("token", response.token);
    }
  };

  if (isLoading) return <Loader />;

  return (
    <>
      {flagGoogle && (
        <GoogleOneTapLogin
          onError={(error) => console.log(error)}
          onSuccess={(response) => {
            localStorage.setItem("email", response.email);
            localStorage.setItem("name", response.name);
            setEmail(response.email);
          }}
          googleAccountConfigs={{
            client_id:
              "301415234328-98f5ceieu7b9j60g62usjculjcb4tec2.apps.googleusercontent.com",
          }}
        />
      )}

      <Pages />

      {firstSegment !== "/detail" &&
        firstSegment !== "/bacaBuku" &&
        firstSegment !== "/audioplayer" &&
        firstSegment !== "/games" && <Footer />}
    </>
  );
};

// Wrapper untuk menyisipkan <BrowserRouter>
const AppWrapper = () => {
  return (
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );
};

export default AppWrapper;
